import { Anchor } from "@twilio-paste/core/anchor";
import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { css, styled } from "@twilio-paste/styling-library";
import React from "react";
import { SiteFooterHeader } from "./SiteFooterHeader";

export const StyledFooterTextContainer = styled(Box)(() =>
    css({
        // 350px is the approx. width of the svg image on the right excluding the whitespace
        width: [null, null, null, "calc(100% - 350px)", "space80"]
    })
);
export function SiteFooterNav() {
    return (
        <Box
            position="relative"
            paddingY={["space0", "space0", "space0", "space180"]}
            paddingX={["space20", "space20", "space20", "space90", "space0"]}
        >
            <SiteFooterHeader />
            <Box display="flex" flexDirection={["column", "row"]} textAlign={["center", "left"]}>
                <StyledFooterTextContainer>
                    <Text as="p" color="colorTextInverse" style={{ whiteSpace: "break-spaces" }}>
                        We all do sometimes; code is hard. Get help now from our{" "}
                        <Anchor variant="inverse" href="https://support.twilio.com/hc/en-us">
                            support team
                        </Anchor>
                        , or lean on the wisdom of the crowd by visiting Twilio&apos;s{" "}
                        <Anchor variant="inverse" href="https://stackoverflow.com/collectives/twilio">
                            Stack Overflow Collective
                        </Anchor>{" "}
                        or browsing the{" "}
                        <Anchor variant="inverse" href="https://stackoverflow.com/questions/tagged/twilio">
                            Twilio tag
                        </Anchor>{" "}
                        on Stack Overflow.
                    </Text>
                </StyledFooterTextContainer>
            </Box>
        </Box>
    );
}
